
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RedeemVoucher from '../components/payments/RedeemVoucher';

function mapStateToProps(state, ownProps) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch),
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch),
      analyticsActions: bindActionCreators(require('actions/analyticsActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RedeemVoucher);


// WEBPACK FOOTER //
// ./src/containers/RedeemVoucherContainer.js